
























































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwCountryIcon } from '@libs-uuif/shared/sw-country-icon';
import { SwSelect } from '@libs-uuif/shared/sw-select';
import Component from 'vue-class-component';
import {
  SwModal,
  SwModalBody,
  SwModalFooter,
} from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { Prop } from 'vue-property-decorator';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { DropdownLight } from '@/shared/dropdown-light';
import {
  SwTabGroup,
  SwTabPage,
} from '@sonicwall/unified-ui-framework/src/shared/sw-tab-layout';
import { SwToggle } from '@sonicwall/unified-ui-framework/src/shared/sw-toggle';
import IdpConfigdetailDialog from './idp-configdetail-dialog.vue';
import IdpChoiceDialog from './idp-choice-dialog.vue';
import UseNewPassword from './use-new-password.vue';

const cssPrefix = 'idp-config';
@Component({
  components: {
    SwCountryIcon,
    SwSelect,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwTextfield,
    DropdownLight,
    SwTabGroup,
    SwTabPage,
    SwToggle,
    IdpConfigdetailDialog,
    IdpChoiceDialog,
    UseNewPassword,
  },
})
export default class IdpConfigDialog extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop({ required: true })
  showIdpConfigDialog: any;
  @Prop({ required: true })
  idpConfigData: any;
  @Prop({ required: true })
  showRemoveIdpDialog: any;
  closeDialog() {
    this.$emit('close-modal');
  }
  choiceOfIDP: any = '';
  screenTitles = ['Choose your Identity Provider'];
  screenTitle = '';
  choosenIDPOkta = true;
  nextButtonClicked = false;
  idpChosen = false;
  testCondition = true;
  infoIcon: boolean;
  appliancePassword: any;
  password: any = '';
  showPasswordNow = false;
  idpStatus = false;
  isReadOnly = false;
  showRefresh = false;
  titleIDP = '';
  spinner = false;
  codeType: string = 'password';
  useNewPasswordDialog: boolean = false;
  created() {
    this.screenTitle = this.screenTitles[0];
    this.infoIcon = this.idpConfigData.infoIcon;
    if (this.idpConfigData.infoIcon) {
      this.choiceOfIDP = 'OKTA';
      this.idpChosen = true;
      this.appliancePassword = this.idpConfigData.appliancePassword;
      this.idpStatus = this.idpConfigData.idpStatus;
      this.isReadOnly = this.idpConfigData.isReadOnly;
    }
    this.password = this.idpConfigData.appliancePassword;
    this.titleIDP = this.isReadOnly
      ? this.$t('idp.viewExternalIDP')
      .toString() : this.$t('idp.addExternalIDP')
      .toString();
    // if (this.idpConfigData.appliancePassword === '') {
    //   this.refreshPassword();
    // }
  }

  toggleInfoIconValue() {
    this.infoIcon = false;
  }

  changeTestCondition(testCondition: any) {
    this.testCondition = testCondition;
  }

  chosenIDP(idpChoice: any) {
    this.choiceOfIDP = idpChoice;
    this.idpChosen = true;
  }

  toggleshowPassword() {
    this.showPasswordNow = !this.showPasswordNow;
    this.showPasswordNow ? this.showPassword() : this.hidePassword();
  }

  showPassword() {
    this.password = this.appliancePassword;
    this.showRefresh = true;
  }

  hidePassword() {
    this.password = '';
    this.showRefresh = false;
  }

  showCode(val: any) {
    val === 'show' ? (this.codeType = 'text') : (this.codeType = 'password');
  }

  onIDPPasswordChange(val: any) {
    this.password = val;
  }

  closeIdpConfigDetailDialog() {
    this.idpChosen = false;
  }
}
